export default __webpack_public_path__ + "static/media/computer-img.a44a6cbd.png";